<script>
import Alerts from "@/components/Alerts";
import Datepicker from 'vuejs-datepicker'
import Multiselect from 'vue-multiselect'

export default {
    name: "Procurement",
    components: {Alerts, Datepicker, Multiselect},

    data() {
        return {
            users: [],
            disabledDates: {
                to: new Date(new Date().setDate(new Date().getDate() - 1)),
                from: new Date(new Date().setDate(new Date().getDate() + 8))
            },

            form: {
                user: '',
                date: new Date()
            }
        }
    },
    mounted() {
        this.$http.get(`users`).then(res => {
            this.users = res.data.data
        })
    }
}
</script>

<template>
    <div>
        <div class="bg-white p-4 mb-2 border rounded">

            <h5 class="font-weight-bold">
                <span class="font-weight-bold">Procurement Form</span> <br>
                <span class="text-muted">(Section A)</span>
            </h5>

            <Alerts :_success="success" :_error="error"></Alerts>

            <div class="bg-secondary text-white font-weight-bold p-1">
                PROCUREMENT DETAILS
            </div>

            <div class="form-group row mt-4">
                <label for="expected_date" class="col-md-4 col-form-label text-md-right">Date of Purchase
                    Request</label>
                <div class="col-md-7">
                    <Datepicker id="expected_date" :bootstrap-styling="true" :disabledDates="disabledDates"
                                v-model="form.date" maximum-view="day" :disabled="wait"
                                placeholder="Select date" :required="true"></Datepicker>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-4 col-form-label text-md-right">Requested By</label>
                <div class="col-md-7">
                    <multiselect
                        class="mb-2"
                        v-model="form.user"
                        :options="users"
                        :disabled="wait"
                        :multiple="false"
                        track-by="id"
                        :preserve-search="true"
                        :hide-selected="true"
                        placeholder="Select user to tag" label="name">
                    </multiselect>
                    <span class="text-muted">Select one user from the list</span>
                </div>
            </div>

            <div class="form-group row">
                <label for="type" class="col-md-4 col-form-label text-md-right">Type of Purchase</label>
                <div class="col-md-7">
                    <select id="type" class="form-control mb-2" v-model="form.type" :disabled="wait" required>
                        <option value="Product">Product/Item</option>
                        <option value="Service">Service</option>
                    </select>
                </div>
            </div>

            <div class="form-group row">
                <label for="type" class="col-md-4 col-form-label text-md-right">Item Description/Specification</label>
                <div class="col-md-7">
                    <textarea class="form-control" rows="4" placeholder="Item Description/Specification"></textarea>
                </div>
            </div>

            <div class="form-group row">
                <label for="type" class="col-md-4 col-form-label text-md-right">Reason for Purchase</label>
                <div class="col-md-7">
                    <textarea class="form-control" rows="2" placeholder="Item Description/Specification"></textarea>
                    <span class="text-muted">Indicate the program/goal the item will be used for</span>
                </div>
            </div>

            <div class="form-group row">
                <label for="expected_date" class="col-md-4 col-form-label text-md-right">Budget Allocated</label>
                <div class="col-md-7">
                    <input class="form-control" v-model="form.amount">
                    <span class="text-muted">Assumption is that the items have been budgeted for in the annual work plan. If not, then that should be indicated</span>
                </div>
            </div>

            <div class="form-group row">
                <label for="expected_date" class="col-md-4 col-form-label text-md-right">Expected Delivery Date</label>
                <div class="col-md-7">
                    <Datepicker id="expected_date" :bootstrap-styling="true" :disabledDates="disabledDates"
                                v-model="form.expected" maximum-view="day" :disabled="wait"
                                placeholder="Select date" :required="true"></Datepicker>
                    <span class="text-muted">When do you expect items to be delivered</span>
                </div>
            </div>


            <div class="form-group row mt-4">
                <div class="offset-4 col-md-7">
                    <button class="btn btn-dark" @click="$router.push('/procurements/view/1')">Submit</button>
                </div>
            </div>
        </div>
    </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

</style>